import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import RankedTable from "../layout/RankedTable";
import AppButton from "../layout/AppButton";
import { formatDateTime } from "../../utils/dateFormat";

const PAGE_SIZE = 15;

const RoleManagementTable = ({
  searchText,
  setSearchText,
  filteredRoles,
  onEditRole,
  onDeleteRole,
  deleteLoadingId,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(filteredRoles.length / PAGE_SIZE);
  const currentData = filteredRoles.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

  const handleSearch = (e) => { setSearchText(e.target.value); setCurrentPage(0); };

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3 px-1">
        <div className="flex items-center gap-3">
          <input
            type="text"
            className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            style={{ minWidth: "280px" }}
            placeholder="Search by role name"
            value={searchText}
            onChange={handleSearch}
          />
         
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"‹"} nextLabel={"›"} breakLabel={"..."}
            pageCount={pageCount} marginPagesDisplayed={1} pageRangeDisplayed={3}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            forcePage={currentPage}
            containerClassName={"pagination"} pageClassName={"page-item"} pageLinkClassName={"page-link"}
            previousClassName={"page-item"} previousLinkClassName={"page-link"}
            nextClassName={"page-item"} nextLinkClassName={"page-link"}
            breakClassName={"page-item"} breakLinkClassName={"page-link"} activeClassName={"active"}
          />
        )}
      </div>

      <RankedTable
        columns={[{ label: "Role Name" }, { label: "Created At" }, { label: "Actions", align: "left", width: "15%" }]}
        rows={currentData}
        emptyText="No matching roles found."
        renderRow={(role) => (<>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="font-bold text-gray-800 text-xs">{role.name}</span>
              {role.createdBy && <span className="text-[11px] text-gray-400">{role.createdBy}</span>}
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-gray-500 text-xs">{formatDateTime(role.createdAt).date}</span>
              <span className="text-gray-400 text-[11px]">{formatDateTime(role.createdAt).time}</span>
            </div>
          </td>
          <td className="px-5 py-3 text-left">
            <div className="flex items-center justify-start gap-2">
              <AppButton
                variant="fill"
                onClick={() => onEditRole(role)}
                style={{ padding: "4px 12px", fontSize: "11px" }}
              >
                Edit
              </AppButton>
              <AppButton
                variant="outline"
                disabled={deleteLoadingId === role.id}
                onClick={() => onDeleteRole(role.id)}
                style={{ padding: "4px 12px", fontSize: "11px" }}
              >
                {deleteLoadingId === role.id ? "Deleting..." : "Delete"}
              </AppButton>
            </div>
          </td>
        </>)}
      />
    </div>
  );
};

export default RoleManagementTable;
